








import {
  defineComponent,
} from '@nuxtjs/composition-api';

import WebShare from '~/components/WebShare.vue';

export default defineComponent({
  name: 'ProductTitle',
  components: { WebShare },
  props: {
    title: {
      type: String,
      default: '',
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
});
